// extracted by mini-css-extract-plugin
export default {"icon":"HH3Qd","iconWhite":"_19Ake","skeleton-progress":"_5aEXX"};